// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ikcihsryqvvqnohpnwni.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlrY2loc3J5cXZ2cW5vaHBud25pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0MDQ1MTMsImV4cCI6MjA2OTk4MDUxM30.aRUv8QO8P6g1UJEcSTEWN9cZOo-9grCuY4zh2bTWHLI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});